/* eslint-disable no-unused-vars */
import axios from 'axios'
import { getAppHost, getAppEndpointVersion } from 'helpers'

// List Knowledge Base
export const list = async (app, appSettings, agentUid, paginationParams = '') => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/knowledge-base`

    // Add pagination params to URL if provided
    const url = paginationParams ? `${baseURL}?${paginationParams}` : baseURL

    const response = await axios.get(url, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Add files to agent knowledge base
export const addFiles = async (app, appSettings, agentUid, payload) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/agents/${agentUid}/knowledge-base/files/add`

    const response = await axios.patch(baseURL, payload, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Remove files from agent knowledge base
export const removeFiles = async (app, appSettings, agentUid, payload) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/agents/${agentUid}/knowledge-base/files/remove`

    const response = await axios.patch(baseURL, payload, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Initiate file uploads
export const initiateUpload = async (app, appSettings, payload) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/knowledge-base/uploads/initiate`

    const response = await axios.post(baseURL, payload, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Get Knowledge Base Details
export const getDetails = async (
  app,
  appSettings,
  sourceType,
  uniqueId,
  page = 1,
  limit = 10,
  affix = null,
) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/knowledge-base/${sourceType}/${uniqueId}/pages`

    const params = {
      page,
      limit,
    }

    // Add affix parameter if provided (append or prepend)
    if (affix) {
      params.affix = affix
    }

    const response = await axios.get(baseURL, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
      params,
    })
    return response.data
  } catch (error) {
    throw error
  }
}

// Delete uploaded file
export const deleteFile = async (app, appSettings, uploadId, fileType) => {
  console.log('Delete File Service called', { uploadId, fileType })

  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/knowledge-base/${fileType}/${uploadId}`

    const response = await axios.delete(baseURL, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Sync knowledge base item
export const sync = async (app, appSettings, sourceType, uniqueId) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/knowledge-base/${sourceType}/${uniqueId}/sync`

    const response = await axios.patch(
      baseURL,
      { data: '' },
      {
        headers: {
          appId: app.id,
          apiKey: app.accessKey,
          'Content-Type': 'application/json',
          Accept: 'application/json',
          chatapiversion: 'v3.0',
        },
      },
    )

    return response.data
  } catch (error) {
    throw error
  }
}

export const createTextKnowledgeBaseItem = async (app, appSettings, payload) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/knowledge-base/text`

    const response = await axios.post(baseURL, payload, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

export const updateTextKnowledgeBaseItem = async (app, appSettings, uniqueId, payload) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/knowledge-base/text/${uniqueId}`

    const response = await axios.patch(baseURL, payload, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

export const getKnowledgeBaseItem = async (app, appSettings, uniqueId, fileType) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/knowledge-base/${fileType}/${uniqueId}`

    const response = await axios.get(baseURL, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Batch get statuses for multiple knowledge base items
export const getStatuses = async (app, appSettings, uniqueIds = []) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/knowledge-base/status/poll`

    const payload = {
      uniqueId: uniqueIds,
    }

    const response = await axios.post(baseURL, payload, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Add source to agent
export const addSourceToAgent = async (app, appSettings, agentUid, source, uniqueIds) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/agents/${agentUid}/knowledge-base/${source}/add`

    const response = await axios.patch(
      baseURL,
      { uniqueIds },
      {
        headers: {
          appId: app.id,
          apiKey: app.accessKey,
          'Content-Type': 'application/json',
          Accept: 'application/json',
          chatapiversion: 'v3.0',
        },
      },
    )

    return response.data
  } catch (error) {
    throw error
  }
}

// Remove source from agent
export const removeSourceFromAgent = async (app, appSettings, agentUid, source, uniqueIds) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/agents/${agentUid}/knowledge-base/${source}/remove`

    const response = await axios.patch(
      baseURL,
      { uniqueIds },
      {
        headers: {
          appId: app.id,
          apiKey: app.accessKey,
          'Content-Type': 'application/json',
          Accept: 'application/json',
          chatapiversion: 'v3.0',
        },
      },
    )

    return response.data
  } catch (error) {
    throw error
  }
}

export const createIndividualLink = async (app, appSettings, payload) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/knowledge-base/website/individual-page`

    const response = await axios.post(baseURL, payload, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

export const scrapeWebsite = async (app, appSettings, payload) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/knowledge-base/website/scrape`

    const response = await axios.post(baseURL, payload, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

export const processDiscoveredUrls = async (app, appSettings, parentUniqueId, payload) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/knowledge-base/website/${parentUniqueId}/discovered-urls/process`

    const response = await axios.post(baseURL, payload, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

export const getDiscoveredUrls = async (
  app,
  appSettings,
  parentUniqueId,
  cursor = null,
  limit = 20,
) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/knowledge-base/website/${parentUniqueId}/discovered-urls`

    const params = {
      limit,
    }

    if (cursor) {
      params.cursor = cursor
    }

    const response = await axios.get(baseURL, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
      params,
    })

    return response.data
  } catch (error) {
    throw error
  }
}

export const getDiscoveredUrlsStatuses = async (app, appSettings, parentUniqueId, uniqueIds = []) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/knowledge-base/website/${parentUniqueId}/discovered-urls/status/poll`

    const payload = {
      uniqueId: uniqueIds,
    }

    const response = await axios.post(baseURL, payload, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

export const syncDiscoveredUrls = async (app, appSettings, parentUniqueId, uniqueIds = []) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/knowledge-base/website/${parentUniqueId}/discovered-urls/sync`

    const payload = {
      uniqueIds,
    }

    const response = await axios.patch(baseURL, payload, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
